import { captureError } from "../monitoring/sentry";
import { classifyError, type AppError } from "./errors";

/** Report an AppError. System errors go to Sentry. Ambient errors are logged only. */
export function reportError(err: unknown, code: string): AppError {
  const appError = classifyError(err, code);
  if (appError.class === "system") {
    captureError(
      appError.cause instanceof Error
        ? appError.cause
        : new Error(appError.userMessage),
      { errorCode: appError.code },
    );
  }
  return appError;
}
